export default "__VITE_ASSET__C_0Bp2yj__"